import React, { useEffect, useState } from 'react';
import { useAddUser, useDeleteUser, useDownloadUsers, useFetchUsers } from '../../hooks/api/users/users';
import { toast } from 'react-toastify';
import { useFetchOrganizations } from '../../hooks/api/organisation/organisation';

import Pagination from '@mui/material/Pagination';
import { LoadingButton } from '@mui/lab';
const usersData = [
  { id: 1, name: 'JohnS Doe', email: 'john.doe@example.com', role: 'Admin', password: 'password123', organization: 'Acme Corp' },
  { id: 2, name: 'Jane Smith', email: 'jane.smith@example.com', role: 'User', password: 'securepass', organization: 'Beta Industries' },
  { id: 3, name: 'Peter Jones', email: 'peter.jones@example.com', role: 'Moderator', password: 'mypassword', organization: 'Gamma Solutions' },
];

// const organizations = ['Acme Corp', 'Beta Industries', 'Gamma Solutions', 'Delta Inc'];

const UserManagement = () => {
    const [filters, setFilters]= useState({
        pageNumber:1,
        pageSize:10,
        search:"",
        orgId:""

    })
    const handlePageChange = (event, value) => {
      setFilters(prev=>({...prev, pageNumber:value}))
    };
  const [users, setUsers] = useState(usersData);
  const [newUser, setNewUser] = useState({ name: '', email: '', role: '', password: '', organization: '' });
  const [editUser, setEditUser] = useState(null);

  const addUserAPI= useAddUser()
  const fetchUserAPI= useFetchUsers(filters)
  const downloadUsers= useDownloadUsers()
 const deleteUserAPI = useDeleteUser()
 const fetchOrganisationAPI= useFetchOrganizations() 
 
 const [organizations, setOrganizations] = useState([]);
 const handleInputChange = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  const handleAddUser = () => {
    if (newUser.password.length < 6) {
      alert("Password must be at least 6 characters long.");
      return;
    }

    toast.dismiss()
    toast.loading(`Adding User`)
    const payload={
        "firstName": newUser.name,
        "orgId":newUser.organization,
        "lastName":newUser.name,
        "email":newUser.email,
        "password":newUser.password,
        "role":newUser.role
    
    }
    addUserAPI.mutate(payload, {

        onSuccess(addUserResponse){
toast.dismiss()
toast.success( `User Added Successfully`)
setUsers([...users, { id: users.length + 1, ...newUser }]);
}, onError(addUserError){
    toast.dismiss()
    toast.error( `Unable to add user`)
    console.log({addUserError})
    
        }, onSettled(){

        }
    })
  
    setNewUser({ name: '', email: '', role: '', password: '', organization: '' });
  };


  const handleDeleteUser = (id) => {
    const isDelete= window.confirm(`Are you sure you want to delete this organization?`)
      if(isDelete){
        toast.dismiss()
        toast.loading(`Adding Project`)
          deleteUserAPI.mutate(id,
              {
                  onSuccess(addProjectResponse){
      toast.dismiss()
      toast.success(`Organisation Deleted Successfully`);
      setUsers(users.filter((user) => user.id !== id));
    }, 
                  onError: (error) => {
                      console.log({error})
                      toast.dismiss()
                      toast.error(   `Unable to delete Organisation`)
                  }
      
              }
          )
  
      }
  
  
   };

  const handleEditUser = (user) => {
    setEditUser({ ...user });
  };

  const handleUpdateUser = () => {
    if (editUser.password && editUser.password.length < 6) {
      alert("Password must be at least 6 characters long.");
      return;
    }
    setUsers(
      users.map((user) => (user.id === editUser.id ? { ...user, ...editUser } : user))
    );
    setEditUser(null);
  };


  useEffect(()=>{
setUsers(fetchUserAPI.data?.users)
setOrganizations(fetchOrganisationAPI.data?.orgs)
    
  }, [fetchUserAPI.data, fetchOrganisationAPI.data])
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">User Management</h1>

      <div className="bg-white rounded-lg shadow-md p-6 mb-4">
        <h2 className="text-xl font-semibold mb-2">Add New User</h2>
        <div className="grid grid-cols-3 gap-4">
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={newUser.name }
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={newUser.email}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
          />
          <select
            name="role"
            value={newUser.role}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
          >
            <option value="">Select Role</option>
            <option value="shopper">Shopper</option>
            <option value="client">Client</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={newUser.password}
          onChange={handleInputChange}
          className="border rounded px-3 py-2 mt-2"
        />
       <select
            name="organization"
            value={newUser.organization}
            onChange={handleInputChange}
            className="mx-4 border rounded px-3 py-2"
            required
          >
            <option value="">Select Organization</option>
            {organizations?.map((org) => (
              <option key={org?.id} value={org?.id}>
                {org?.name}
              </option>
            ))}
          </select>
        <button
          onClick={handleAddUser}
          className=" bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Add User
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
<div className="">

        <h2 className="text-xl font-semibold ">User List</h2>
<input type="search" className='mt-4 border p-4 w-96 rounded-md' placeholder='Search by name' />
</div>

        <div className="">
          <button 
          onClick={e=>downloadUsers.mutate(filters)}
          className="btn px-8 py-4 rounded-md bg-green-300 text-white">Download users</button>
        </div>
      </div>
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr >
              <th className="px-4 py-2 text-left ">Name</th>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">Role</th>
              <th className="px-4 py-2 text-left">Unique Code</th>
              <th className="px-4 py-2 text-left">Organization</th>
              <th className="px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users?.map((user) => (
              <tr key={user.id}>
                <td className="px-4 py-2">{user.name || user.firstName}</td>
                <td className="px-4 py-2">{user.email}</td>
                <td className="px-4 py-2">{user.role}</td>
                <td className="px-4 py-2">{user?.uniqueCode
}</td>
                <td className="px-4 py-2">{organizations?.find(x=>x.id===user?.orgId)?.name}</td>
                <td className="px-4 py-2 flex gap-2">
                  <button
                    onClick={() => handleEditUser(user)}
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDeleteUser(user.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="my-4">
{
  fetchUserAPI.isLoading && <div className="">
    <p>Loading...please wait</p>
  </div>
}
        <Pagination count={fetchUserAPI.data?.pagination?.totalPages} page={filters.pageNumber} onChange={handlePageChange} />
        </div>
      </div>

      {editUser && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-2">Edit User</h2>
            <input
              type="text"
              name="name"
              value={editUser.name}
              onChange={(e) => setEditUser({ ...editUser, name: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
            />
            <input
              type="email"
              name="email"
              value={editUser.email}
              onChange={(e) => setEditUser({ ...editUser, email: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
            />
            <select
              name="role"
              value={editUser.role}
              onChange={(e) => setEditUser({ ...editUser, role: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
            >
              <option value="">Select Role</option>
              <option value="admin">Admin</option>
              <option value="client">User</option>
              <option value="shopper">Shopper</option>
            </select>
            <input
              type="password"
              name="password"
              placeholder="New Password (Leave blank to keep current)"
              value={editUser.password || ''}
              onChange={(e) => setEditUser({ ...editUser, password: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
            />
         <select
            name="organization"
            value={editUser.organization}
            onChange={handleInputChange}
            className="mx-4 border rounded px-3 py-2"
            required
          >
            <option value="">Select Organization</option>
            {organizations.map((org) => (
              <option key={org?.id} value={org?.id}>
                {org?.name}
              </option>
            ))}
          </select>
            <button
               onClick={handleUpdateUser}
               className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
             >
               Update
             </button>
             <button
               onClick={() => setEditUser(null)}
               className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
             >
               Cancel
             </button>
           </div>
         </div>
       )}
     </div>
   );
 };
 
 export default UserManagement;
 